import { Landmark, FileCheck2, ShieldCheck } from "lucide-react";
import { ServiceLanding } from "@/components/ServiceLanding";

const cfg = {
  prefix: "audit-prep",
  pageTitle: "Audit Preparation Services | Single Audits & PBC Support | CalCor Solutions",
  topbarLabel: "Audit preparation · Seattle & remote",
  eyebrow: "Audit Preparation Services",
  heroTitle: (
    <>
      Walk into audit season <em className="text-pine">already ready.</em>
    </>
  ),
  heroSub:
    "CalCor Solutions prepares your organization so fieldwork confirms your discipline instead of exposing your stress — audit-ready workpapers, clean reconciliations, and PBC coordination for small businesses, nonprofits, and tribal governments, including Uniform Guidance single audits.",
  formHeading: "Start with a free readiness review.",
  formSub: "Tell us when your audit is — we'll tell you exactly what stands between you and ready.",
  messageLabel: "When is your audit, and what's worrying you? *",
  formPlaceholder: "e.g. Single audit in November, last year's PBC list was chaos, need workpaper support…",
  submitLabel: "Get my audit-prep quote",
  quoteCta: "Get a fixed-fee quote",
  serviceValue: "Audit preparation",
  audienceHeading: (
    <>
      Built for teams facing <em className="text-pine">a real audit.</em>
    </>
  ),
  audiences: [
    {
      icon: Landmark,
      title: "Tribal governments",
      desc: "Single audit (Uniform Guidance) readiness, SEFA support, and fund-level workpapers — paced to council calendars and handled with discretion.",
    },
    {
      icon: FileCheck2,
      title: "Nonprofits & grant-funded orgs",
      desc: "Federal awards bring audit requirements. We organize the documentation auditors actually test — allowable costs, eligibility, procurement.",
    },
    {
      icon: ShieldCheck,
      title: "Businesses facing a first audit",
      desc: "Lender, investor, or board requiring audited statements? We get your books and workpapers ready so the first audit sets a strong precedent.",
    },
  ],
  includedHeading: (
    <>
      Fieldwork, <em className="text-pine">de-fanged.</em>
    </>
  ),
  includedSub:
    "We prepare everything your auditors will ask for — before they ask — and stay in the room (virtually or in person) until the report is issued.",
  included: [
    "Audit-ready workpapers and lead schedules",
    "Account reconciliations with clear support",
    "PBC list management — every item has a home",
    "SEFA preparation support for single audits",
    "Internal control review and remediation",
    "Direct liaison with your audit firm",
    "Fixed-fee scope agreed before we start",
    "Post-audit adjustments and next-year fixes",
  ],
  testimonialsHeading: (
    <>
      Fifteen years of <em className="text-pine">calm audit seasons.</em>
    </>
  ),
  testimonials: [
    {
      quote: "Audit season used to mean panic. Now our workpapers are ready before the auditors even ask.",
      by: "Finance Director, tribal government",
      where: "Pacific Northwest",
    },
    {
      quote: "CalCor untangled two years of messy books in a single quarter. Our lender actually complimented the reporting package.",
      by: "Owner, family-run retail group",
      where: "Tacoma, WA",
    },
    {
      quote: "They answer in plain English, hit every deadline, and our board finally understands the numbers.",
      by: "Executive Director, regional nonprofit",
      where: "Seattle, WA",
    },
  ],
  finalTitle: (
    <>
      Make this audit <em className="text-paper/70">the boring one.</em>
    </>
  ),
  finalSub:
    "Tell us when fieldwork starts. You will hear back within one business day with a readiness plan and a fixed fee — no pressure, no jargon.",
};

export default function AuditPreparation() {
  return <ServiceLanding cfg={cfg} />;
}
